let payList = [
  {value: '0', text: "全部"},
  {value: '1', text: "微信"},
  {value: '2', text: "支付宝"},
  {value: '3', text: "苹果支付"},
  {value: '4', text: "谷歌支付"},
  {value: '5', text: "palpay支付"},
  {value: '6', text: "其他支付"}
]
let typeList = [
  {value: '1', text: '系统充值'},
  {value: '2', text: '家族入驻'},
  {value: '3', text: '家族扶持'},
  {value: '4', text: '活动奖励'},
  {value: '5', text: '内部发放'},
  {value: '6', text: '其他奖励'},
  {value: '7', text: '代理充值'},
  {value: '8', text: '房间扶持'},
  {value: '9', text: '外管奖励'},
]
let currencyList = [
  {value: '1', text: '美金'},
  {value: '0', text: '人民币'},
]
let statusList = [
  {
    value: 1,
    text: "全部"
  }, {
    value: 2,
    text: "已通过"
  }, {
    value: 3,
    text: "已拒绝"
  },
]
let timeList = [
  {
    text: '封禁24小时',
    value: 1
  }, {
    text: '封禁72小时',
    value: 3
  }, {
    text: '封禁30天',
    value: 30
  }, {
    text: '永久封禁',
    value: 0
  }
]
let shop_typeList = [
  {value: 0, text: '全部'},
  {value: 1, text: '座驾'},
  {value: 2, text: '勋章'},
  {value: 3, text: '头饰'},
  {value: 4, text: '靓号'},
  {value: 5, text: 'VIP'},
]
let is_activateList = [
  {value: 0, text: '全部'},
  {value: 1, text: '已激活'},
  {value: 2, text: '未激活'}
]
let systemList = [
  {value: 0, text: '全部'},
  {value: 1, text: 'android系统'},
  {value: 2, text: 'IOS系统'}
]
let language = [
  {value: '1', text: '阿语'},
  {value: '2', text: '英语'},
  {value: '3', text: '土语'},
  {value: '4', text: '印尼语'},
]
let frozen_typeList = [
  {
    text: '无',
    value: 0
  }, {
    text: '色情/性',
    value: 1
  }, {
    text: '侮辱谩骂',
    value: 2
  }, {
    text: '不尊重宗教',
    value: 3
  },
  {
    text: '恐怖活动',
    value: 4
  }, {
    text: '违法违规',
    value: 5
  }, {
    text: '宣传其他App',
    value: 6
  }, {
    text: '重置头像',
    value: 7
  }
]
let countrys = [{
  value: '0',
  "text": "全部"
},
  {
    "text": "Algeria",
    value: "1"
  },
  {
    "text": "Australia",
    value: "2"
  },
  {
    "text": "Austria",
    value: "3"
  }, {
    "text": "Bahrain",
    value: "4"
  },
  {
    "text": "Bangladesh",
    value: "5"
  },
  {
    "text": "Canada",
    value: "6"
  },
  {
    "text": "China",
    value: "7"
  },
  {
    "text": "Egypt",
    value: "8"
  },
  {
    "text": "Ethiopia",
    value: "9"
  },
  {
    "text": "France",
    value: "10"
  }, {
    "text": "Germany",
    value: "11"
  }, {
    "text": "India",
    value: "12"
  }, {
    "text": "Indonesia",
    value: "13"
  }, {
    "text": "Iraq",
    value: "14"
  }, {
    "text": "Italy",
    value: "15"
  }, {
    "text": "Japan",
    value: "16"
  }, {
    "text": "Jordan",
    value: "17"
  }, {
    "text": "KSA",
    value: "18"
  }, {
    "text": "Kuwait",
    value: "19"
  }, {
    "text": "Lebanon",
    value: "20"
  }, {
    "text": "Libya",
    value: "21"
  }, {
    "text": "Malaysia",
    value: "22"
  }, {
    "text": "Morocco",
    value: "23"
  }, {
    "text": "Netherlands",
    value: "24"
  }, {
    "text": "Oman",
    value: "25"
  }, {
    "text": "Pakistan",
    value: "26"
  }, {
    "text": "Palestine",
    value: "27"
  }, {
    "text": "Philippines",
    value: "28"
  }, {
    "text": "Qatar",
    value: "29"
  }, {
    "text": "Russia",
    value: "30"
  }, {
    "text": "Spain",
    value: "31"
  }, {
    "text": "Sudan",
    value: "32"
  }, {
    "text": "Tunisia",
    value: "33"
  }, {
    "text": "Turkey",
    value: "34"
  }, {
    "text": "UAE",
    value: "35"
  }, {
    "text": "UK",
    value: "36"
  }, {
    "text": "Ukraine",
    value: "37"
  }, {
    "text": "USA",
    value: "38"
  }, {
    "text": "Yemen",
    value: "39"
  }, {
    "text": "Syria",
    value: "40"
  }, {
    "text": "Iran",
    value: "41"
  }, {
    "text": "Afghanistan",
    value: "42"
  }, {
    "text": "Swiss",
    value: "43"
  }
]
let areaList = [
  {value: '1', text: '全部'},
  {value: '2', text: '阿语地区'},
  {value: '3', text: '土耳其语地区'},
  {value: '4', text: '印尼语地区'},
  {value: '5', text: '其他(英语)'},
]
let areatext = [
  {value: 'en', text: '英语'},
  {value: 'tr', text: '土耳其'},
  {value: 'ar', text: '土耳其语地区'},
  {value: 'in', text: '印尼'}
]
let dicytionary = {
  payList: payList,//支付方式
  typeList: typeList,//奖品来源
  currencyList: currencyList,//人民币、美金
  statusList: statusList,//是否通过
  timeList: timeList,//封禁时长
  shop_typeList: shop_typeList, //商品类型
  frozen_typeList: frozen_typeList,// 封禁原因
  countrys: countrys, //国家
  is_activateList: is_activateList,//是否激活
  systemList: systemList,//手机系统
  language: language,//语言
  areaList: areaList,//地区
  areatext: areatext,//地区

}

function setText(list, value) {
  let sureList = dicytionary[list]
  if (value != undefined) {
    for (var i in sureList) {
      if (sureList[i].value == value) {
        return sureList[i].text
      }
    }
  } else {
    return sureList
  }


}

export default setText



// WEBPACK FOOTER //
// ./src/js/dictionary.js